<!-- 预约填表项（type=39）- 设置预约服务时间弹层 -->
<template>
  <el-dialog
    :visible="visible"
    @update:visible="handleVisibleChange"
    width="580px"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="appointmentTimeDialog"
  >
    <template slot="title">
      <CustomDialogHeader :title="dialogTitle" @close="handleClose" />
    </template>
    <div class="apt-body">
      <div class="apt-readonly-tip" v-if="isWholeReadOnly">
        该预约项已有报名记录，无法修改配置
      </div>
      <!-- 日历 -->
      <div class="apt-calendar">
        <div class="apt-cal-header">
          <div class="apt-cal-nav">
            <span class="apt-nav-btn" @click="switchMonth(-12)">«</span>
            <span class="apt-nav-btn" @click="switchMonth(-1)">‹</span>
            <span class="apt-cal-title"
              >{{ currentYear }}年{{ currentMonth }}月</span
            >
            <span class="apt-nav-btn" @click="switchMonth(1)">›</span>
            <span class="apt-nav-btn" @click="switchMonth(12)">»</span>
          </div>
          <el-button
            size="mini"
            :disabled="isWholeReadOnly"
            @click="openBatchRange"
            >批量选取</el-button
          >
        </div>
        <div class="apt-week-row">
          <span v-for="w in weekDays" :key="w">{{ w }}</span>
        </div>
        <div class="apt-grid">
          <div
            v-for="(cell, cellIndex) in calendarCells"
            :key="cellIndex"
            class="apt-cell"
            :class="cellClass(cell)"
            @click="toggleDate(cell)"
          >
            <template v-if="!cell.blank">
              <span>{{ cell.day }}</span>
              <i v-if="cell.selected" class="el-icon-check apt-check"></i>
            </template>
          </div>
        </div>
        <div class="apt-tip">
          提示：点击选择预约服务日期（最多30个），过去日期不可新选
        </div>
      </div>
      <!-- 模式 Tab -->
      <div class="apt-mode-row">
        <el-radio-group
          v-model="timeMode"
          :disabled="isWholeReadOnly || hasBookedSlots"
          @change="handleModeChange"
        >
          <el-radio-button label="custom">单独设置时段</el-radio-button>
          <el-radio-button label="cycle">统一设置时段</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 时段区 -->
      <div class="apt-slots">
        <div class="apt-slots-header">
          <span class="apt-slots-title">时间段及名额</span>
          <span class="apt-selected-count"
            >已选择{{ selectedDates.length }}个预约日期</span
          >
          <span
            class="apt-quota-btn"
            :class="{ 'is-disabled': isWholeReadOnly }"
            @click="openQuotaDialog"
            >批量设置名额</span
          >
        </div>
        <div v-if="selectedDates.length === 0" class="apt-empty">
          请先在上方日历选择预约服务日期
        </div>
        <!-- custom：按日期分组 -->
        <template v-else-if="timeMode === 'custom'">
          <div
            v-for="group in groupedCustomSlots"
            :key="group.date"
            class="apt-date-group"
          >
            <div class="apt-date-title">{{ formatDisplayDate(group.date) }}</div>
            <div
              v-for="(row, rowIndex) in group.rows"
              :key="rowIndex"
              class="apt-slot-row"
            >
              <el-time-picker
                v-model="row.startTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="开始时间"
                size="small"
                :clearable="false"
                :disabled="isRowLocked(row) || isWholeReadOnly"
              ></el-time-picker>
              <span class="apt-zhi">至</span>
              <el-time-picker
                v-model="row.endTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="结束时间"
                size="small"
                :clearable="false"
                :disabled="isRowLocked(row) || isWholeReadOnly"
              ></el-time-picker>
              <el-input
                class="apt-quota-input"
                size="small"
                maxlength="10"
                :value="row.quota === -1 ? '' : String(row.quota)"
                placeholder="名额不限"
                :disabled="isRowLocked(row) || isWholeReadOnly"
                @input="handleQuotaInput($event, row)"
              ></el-input>
              <i
                class="el-icon-remove-outline apt-del"
                :class="{ 'is-disabled': isRowLocked(row) || isWholeReadOnly }"
                @click="removeSlot(row)"
              ></i>
              <span v-if="isRowLocked(row)" class="apt-lock-text"
                >已有报名</span
              >
            </div>
            <div
              v-if="!isWholeReadOnly"
              class="apt-add-slot"
              @click="addSlot(group.date)"
            >
              +添加时间段
            </div>
          </div>
        </template>
        <!-- cycle：全局统一时段 -->
        <template v-else>
          <div
            v-for="(row, rowIndex) in cycleSlots"
            :key="rowIndex"
            class="apt-slot-row"
          >
            <el-time-picker
              v-model="row.startTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              size="small"
              :clearable="false"
              :disabled="isWholeReadOnly"
            ></el-time-picker>
            <span class="apt-zhi">至</span>
            <el-time-picker
              v-model="row.endTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              size="small"
              :clearable="false"
              :disabled="isWholeReadOnly"
            ></el-time-picker>
            <el-input
              class="apt-quota-input"
              size="small"
              maxlength="10"
              :value="row.quota === -1 ? '' : String(row.quota)"
              placeholder="名额不限"
              :disabled="isWholeReadOnly"
              @input="handleQuotaInput($event, row)"
            ></el-input>
            <i
              class="el-icon-remove-outline apt-del"
              :class="{ 'is-disabled': isWholeReadOnly }"
              @click="removeCycleSlot(rowIndex)"
            ></i>
          </div>
          <div
            v-if="!isWholeReadOnly"
            class="apt-add-slot"
            @click="addCycleSlot"
          >
            +添加时间段
          </div>
          <div class="apt-tip">
            统一时段将应用到全部 {{ selectedDates.length }} 个已选日期
          </div>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        :disabled="isWholeReadOnly"
        @click="handleSave"
        >保 存</el-button
      >
    </span>
    <!-- 批量选取日期弹层 -->
    <el-dialog
      :visible.sync="batchRangeVisible"
      width="420px"
      :show-close="false"
      append-to-body
    >
      <template slot="title">
        <CustomDialogHeader
          title="批量选取日期"
          @close="batchRangeVisible = false"
        />
      </template>
      <div class="apt-batch-row">
        <el-date-picker
          v-model="batchStart"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
          size="small"
          :clearable="false"
          :picker-options="startPickerOptions"
        ></el-date-picker>
        <span class="apt-zhi">至</span>
        <el-date-picker
          v-model="batchEnd"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
          size="small"
          :clearable="false"
          :picker-options="endPickerOptions"
        ></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchRangeVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchRange">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量设置名额弹层 -->
    <el-dialog
      :visible.sync="quotaDialogVisible"
      width="30%"
      :show-close="false"
      append-to-body
    >
      <template slot="title">
        <CustomDialogHeader
          title="批量设置名额"
          @close="quotaDialogVisible = false"
        />
      </template>
      <el-input
        v-model="quotaInput"
        type="number"
        maxlength="10"
        placeholder="名额不限"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quotaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmQuota">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
import {
  normalizeQuota,
  parseDateTime,
  padDateStr,
  extractTime,
  buildSlotDateTime,
  hasOverlappingPeriods,
  hasOverlappingSlots,
  groupTimeSlotsByDate,
  expandCycleSlots,
} from "@/utils/appointmentField.js";

var dayjs = require("dayjs");

const WEEK_DAYS = ["一", "二", "三", "四", "五", "六", "日"];
const WEEK_CN = ["日", "一", "二", "三", "四", "五", "六"];
const MAX_DATES = 30;

export default {
  name: "AppointmentTimeDialog",
  components: { CustomDialogHeader },
  props: {
    visible: { type: Boolean, default: false },
    optionData: { type: Object, default: null },
  },
  data() {
    const now = new Date();
    return {
      currentYear: now.getFullYear(),
      currentMonth: now.getMonth() + 1,
      weekDays: WEEK_DAYS,
      selectedDates: [],
      timeMode: "custom", // custom=单独设置时段 cycle=统一设置时段
      customSlots: [], // 编辑态行：{id?, date, startTime:"HH:mm", endTime:"HH:mm", quota, selectCount?, remaining?}
      cycleSlots: [], // 模板行：{startTime, endTime, quota}
      cycleBooked: false, // cycle 数据存在报名记录（整体只读）
      batchRangeVisible: false,
      batchStart: "",
      batchEnd: "",
      quotaDialogVisible: false,
      quotaInput: "",
      startPickerOptions: {
        disabledDate: (time) =>
          time.getTime() < dayjs().startOf("day").valueOf(),
      },
      endPickerOptions: {
        disabledDate: (time) => {
          const min = this.batchStart
            ? dayjs(this.batchStart).startOf("day").valueOf()
            : dayjs().startOf("day").valueOf();
          return time.getTime() < min;
        },
      },
    };
  },
  computed: {
    dialogTitle() {
      const name = this.optionData && this.optionData.optionName;
      return name ? `设置预约服务时间-${name}` : "设置预约服务时间";
    },
    todayStr() {
      return dayjs().format("YYYY-MM-DD");
    },
    calendarCells() {
      const cells = [];
      const first = new Date(this.currentYear, this.currentMonth - 1, 1);
      const offset = (first.getDay() + 6) % 7; // 周一为首列
      for (let i = 0; i < offset; i++) {
        cells.push({ blank: true });
      }
      const days = new Date(this.currentYear, this.currentMonth, 0).getDate();
      for (let d = 1; d <= days; d++) {
        const dateStr = `${this.currentYear}-${String(
          this.currentMonth
        ).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
        cells.push({
          blank: false,
          day: d,
          date: dateStr,
          past: dateStr < this.todayStr,
          selected: this.selectedDates.indexOf(dateStr) !== -1,
        });
      }
      return cells;
    },
    groupedCustomSlots() {
      return this.selectedDates.map((date) => ({
        date,
        rows: this.customSlots.filter((s) => s.date === date),
      }));
    },
    hasBookedSlots() {
      return (
        this.cycleBooked ||
        this.customSlots.some((s) => (s.selectCount || 0) > 0)
      );
    },
    isWholeReadOnly() {
      return this.timeMode === "cycle" && this.cycleBooked;
    },
  },
  watch: {
    visible(val) {
      if (val) this.initFromOption();
    },
  },
  methods: {
    // 打开时从 optionData 初始化
    initFromOption() {
      const option = this.optionData || {};
      let slots = Array.isArray(option.timeSlots) ? option.timeSlots : [];
      // 旧格式兼容：appointmentTimeList [{date, timeList:[{startTime,endTime,maxNum}]}]
      if (!slots.length && Array.isArray(option.appointmentTimeList)) {
        const migrated = [];
        option.appointmentTimeList.forEach((d) => {
          (d.timeList || []).forEach((t) => {
            migrated.push({
              startTime: buildSlotDateTime(padDateStr(d.date), t.startTime),
              endTime: buildSlotDateTime(padDateStr(d.date), t.endTime),
              quota: normalizeQuota(t.maxNum),
            });
          });
        });
        slots = migrated;
      }
      const dateSet = {};
      slots.forEach((s) => {
        const date = padDateStr((s.startTime || "").split(" ")[0]);
        if (date) dateSet[date] = true;
      });
      this.selectedDates = Object.keys(dateSet).sort();
      this.timeMode = option.timeSlotType === 2 ? "cycle" : "custom";
      this.customSlots = slots.map((s) => ({
        ...s,
        date: padDateStr((s.startTime || "").split(" ")[0]),
        startTime: extractTime(s.startTime),
        endTime: extractTime(s.endTime),
        quota: normalizeQuota(s.quota),
      }));
      this.cycleBooked = slots.some((s) => (s.selectCount || 0) > 0);
      if (this.timeMode === "cycle") {
        this.cycleSlots = this.extractCycleTemplates(slots);
      } else {
        this.cycleSlots = [];
      }
      if (this.selectedDates.length) {
        const parts = this.selectedDates[0].split("-");
        this.currentYear = Number(parts[0]);
        this.currentMonth = Number(parts[1]);
      } else {
        const now = new Date();
        this.currentYear = now.getFullYear();
        this.currentMonth = now.getMonth() + 1;
      }
    },
    // cycle 模板按 HH:mm-HH:mm 去重提取
    extractCycleTemplates(slots) {
      const map = {};
      (slots || []).forEach((s) => {
        const st = extractTime(s.startTime);
        const et = extractTime(s.endTime);
        const key = `${st}-${et}`;
        if (!map[key]) {
          map[key] = { startTime: st, endTime: et, quota: normalizeQuota(s.quota) };
        }
      });
      return Object.keys(map).map((k) => map[k]);
    },
    // 用户点击 Tab 切换模式（el-radio-group @change 仅用户交互触发，程序式赋值不触发）
    handleModeChange(val) {
      this.convertSlots(val);
    },
    // 模式切换时的数据转换（有报名时切换已被禁用）
    convertSlots(val) {
      if (val === "cycle") {
        const map = {};
        this.customSlots.forEach((r) => {
          if (r.startTime && r.endTime) {
            const key = `${r.startTime}-${r.endTime}`;
            // first-wins，与 extractCycleTemplates 去重语义一致
            if (!map[key]) {
              map[key] = {
                startTime: r.startTime,
                endTime: r.endTime,
                quota: normalizeQuota(r.quota),
              };
            }
          }
        });
        this.cycleSlots = Object.keys(map).map((k) => map[k]);
        if (!this.cycleSlots.length && this.selectedDates.length) {
          this.cycleSlots.push({ startTime: "00:00", endTime: "23:59", quota: -1 });
        }
      } else {
        const expanded = [];
        this.selectedDates.forEach((date) => {
          this.cycleSlots.forEach((tpl) => {
            expanded.push({
              date,
              startTime: tpl.startTime,
              endTime: tpl.endTime,
              quota: normalizeQuota(tpl.quota),
            });
          });
        });
        this.customSlots = expanded;
      }
    },
    switchMonth(offset) {
      const d = new Date(this.currentYear, this.currentMonth - 1 + offset, 1);
      this.currentYear = d.getFullYear();
      this.currentMonth = d.getMonth() + 1;
    },
    cellClass(cell) {
      return {
        "is-blank": cell.blank,
        "is-past": !cell.blank && cell.past && !cell.selected,
        "is-selected": !cell.blank && cell.selected,
        "is-clickable": !cell.blank && (!cell.past || cell.selected),
      };
    },
    isRowLocked(row) {
      return (row.selectCount || 0) > 0;
    },
    isDateLocked(dateStr) {
      return this.customSlots.some(
        (s) => s.date === dateStr && (s.selectCount || 0) > 0
      );
    },
    toggleDate(cell) {
      if (cell.blank || this.isWholeReadOnly) return;
      const dateStr = cell.date;
      const index = this.selectedDates.indexOf(dateStr);
      if (index !== -1) {
        // 取消选中：有报名的日期不可取消；联动删除该日期时段
        if (this.isDateLocked(dateStr)) {
          this.$message({
            showClose: true,
            message: "该时段已有报名，不可修改",
            type: "warning",
          });
          return;
        }
        this.selectedDates.splice(index, 1);
        this.customSlots = this.customSlots.filter((s) => s.date !== dateStr);
        return;
      }
      if (cell.past) return; // 过去日期不可新选
      if (this.selectedDates.length >= MAX_DATES) {
        this.$message({
          showClose: true,
          message: "最多只能选择30个预约日期",
          type: "warning",
        });
        return;
      }
      this.selectedDates.push(dateStr);
      this.selectedDates.sort();
      if (this.timeMode === "custom") {
        this.customSlots.push({
          date: dateStr,
          startTime: "00:00",
          endTime: "23:59",
          quota: -1,
        });
      } else if (this.cycleSlots.length === 0) {
        this.cycleSlots.push({ startTime: "00:00", endTime: "23:59", quota: -1 });
      }
    },
    openBatchRange() {
      if (this.isWholeReadOnly) return;
      this.batchStart = "";
      this.batchEnd = "";
      this.batchRangeVisible = true;
    },
    confirmBatchRange() {
      if (!this.batchStart || !this.batchEnd) {
        this.$message({
          showClose: true,
          message: "请选择开始和结束日期",
          type: "warning",
        });
        return;
      }
      const days = [];
      let cur = dayjs(this.batchStart);
      const end = dayjs(this.batchEnd);
      while (cur.isBefore(end, "day") || cur.isSame(end, "day")) {
        days.push(cur.format("YYYY-MM-DD"));
        cur = cur.add(1, "day");
      }
      const newDays = days.filter((d) => this.selectedDates.indexOf(d) === -1);
      if (this.selectedDates.length + newDays.length > MAX_DATES) {
        this.$message({
          showClose: true,
          message: "最多只能选择30个预约日期",
          type: "warning",
        });
        return;
      }
      if (newDays.length === 0) {
        this.batchRangeVisible = false;
        return;
      }
      this.selectedDates = this.selectedDates.concat(newDays).sort();
      if (this.timeMode === "custom") {
        newDays.forEach((date) => {
          this.customSlots.push({
            date,
            startTime: "00:00",
            endTime: "23:59",
            quota: -1,
          });
        });
      } else if (this.cycleSlots.length === 0) {
        this.cycleSlots.push({ startTime: "00:00", endTime: "23:59", quota: -1 });
      }
      const parts = newDays[0].split("-");
      this.currentYear = Number(parts[0]);
      this.currentMonth = Number(parts[1]);
      this.batchRangeVisible = false;
      this.$message({
        showClose: true,
        message: `已添加 ${newDays.length} 个日期`,
        type: "success",
      });
    },
    addSlot(date) {
      this.customSlots.push({ date, startTime: "", endTime: "", quota: -1 });
    },
    removeSlot(row) {
      if (this.isRowLocked(row) || this.isWholeReadOnly) return;
      const index = this.customSlots.indexOf(row);
      if (index !== -1) this.customSlots.splice(index, 1);
    },
    addCycleSlot() {
      this.cycleSlots.push({ startTime: "", endTime: "", quota: -1 });
    },
    removeCycleSlot(index) {
      if (this.isWholeReadOnly) return;
      this.cycleSlots.splice(index, 1);
    },
    handleQuotaInput(val, row) {
      row.quota = val === "" ? -1 : val;
    },
    openQuotaDialog() {
      if (this.isWholeReadOnly) return;
      if (this.selectedDates.length === 0) {
        this.$message({
          showClose: true,
          message: "请先设置预约时间",
          type: "warning",
        });
        return;
      }
      const targets =
        this.timeMode === "custom" ? this.customSlots : this.cycleSlots;
      if (targets.length === 0) {
        this.$message({
          showClose: true,
          message: "请添加时间段",
          type: "warning",
        });
        return;
      }
      this.quotaInput = "";
      this.quotaDialogVisible = true;
    },
    confirmQuota() {
      let quota = -1;
      if (this.quotaInput !== "") {
        const n = parseInt(this.quotaInput, 10);
        if (Number.isNaN(n) || n < 0) {
          this.$message({
            showClose: true,
            message: "请输入有效的名额数量",
            type: "warning",
          });
          return;
        }
        quota = n;
      }
      const targets =
        this.timeMode === "custom" ? this.customSlots : this.cycleSlots;
      targets.forEach((s) => {
        if (!this.isRowLocked(s)) s.quota = quota;
      });
      this.quotaDialogVisible = false;
      this.$message({
        showClose: true,
        message: `已批量设置名额为 ${quota === -1 ? "不限" : quota}`,
        type: "success",
      });
    },
    formatDisplayDate(dateStr) {
      const d = dayjs(dateStr);
      return `${d.month() + 1}月${d.date()}日（周${WEEK_CN[d.day()]}）`;
    },
    // 校验并构建保存产出
    validateAndBuild() {
      let finalSlots;
      if (this.timeMode === "custom") {
        if (this.customSlots.length === 0) {
          return { ok: false, message: "请至少添加一个时段" };
        }
        for (const row of this.customSlots) {
          if (!row.startTime || !row.endTime) {
            return { ok: false, message: "时间段开始和结束时间不能为空" };
          }
          if (row.endTime <= row.startTime) {
            return { ok: false, message: "结束时间必须晚于开始时间" };
          }
        }
        const groups = groupTimeSlotsByDate(
          this.customSlots.map((r) => ({
            startTime: buildSlotDateTime(r.date, r.startTime),
            endTime: buildSlotDateTime(r.date, r.endTime),
          }))
        );
        for (const g of groups) {
          if (hasOverlappingSlots(g.slots)) {
            return { ok: false, message: `${g.date} 时间段存在重叠` };
          }
        }
        finalSlots = this.customSlots.map((r) => {
          const rest = { ...r };
          delete rest.date;
          delete rest.startTime;
          delete rest.endTime;
          delete rest.quota;
          return {
            ...rest, // 保留 id/selectCount/remaining 等回填字段
            startTime: buildSlotDateTime(r.date, r.startTime),
            endTime: buildSlotDateTime(r.date, r.endTime),
            quota: normalizeQuota(r.quota),
          };
        });
      } else {
        if (this.selectedDates.length === 0 || this.cycleSlots.length === 0) {
          return { ok: false, message: "请至少添加一个时段" };
        }
        for (const row of this.cycleSlots) {
          if (!row.startTime || !row.endTime) {
            return { ok: false, message: "时间段开始和结束时间不能为空" };
          }
          if (row.endTime <= row.startTime) {
            return { ok: false, message: "结束时间必须晚于开始时间" };
          }
        }
        if (hasOverlappingPeriods(this.cycleSlots)) {
          return { ok: false, message: "时间段存在重叠" };
        }
        finalSlots = expandCycleSlots(this.selectedDates, this.cycleSlots);
      }
      finalSlots.sort(
        (a, b) => parseDateTime(a.startTime) - parseDateTime(b.startTime)
      );
      return { ok: true, timeSlots: finalSlots };
    },
    handleSave() {
      if (this.isWholeReadOnly) return;
      const result = this.validateAndBuild();
      if (!result.ok) {
        this.$message({
          showClose: true,
          message: result.message,
          type: "warning",
        });
        return;
      }
      this.$emit("save", {
        timeSlots: result.timeSlots,
        timeSlotType: this.timeMode === "custom" ? 1 : 2,
      });
    },
    handleVisibleChange(val) {
      this.$emit("update:visible", val);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/* header 上下间距一致：标题上下各 14px（element 默认 header padding-top 20px 会造成上宽下窄） */
::v-deep .appointmentTimeDialog {
  .el-dialog__header {
    padding-top: 4px;
  }
  .el-dialog__body {
    padding-top: 25px;
  }
}
.apt-body {
  max-height: 60vh;
  overflow-y: auto;
}
.apt-readonly-tip {
  color: #f56c6c;
  font-size: 13px;
  margin-bottom: 10px;
}
.apt-calendar {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
}
.apt-cal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.apt-cal-nav {
  display: flex;
  align-items: center;
  gap: 10px;
}
.apt-nav-btn {
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
  user-select: none;
  padding: 0 4px;
}
.apt-cal-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.apt-week-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  color: #909399;
  font-size: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #f2f6fc;
}
.apt-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  padding-top: 6px;
}
.apt-cell {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  position: relative;
  border: 1px solid transparent;
  &.is-clickable {
    cursor: pointer;
    border-color: #dcdfe6;
    &:hover {
      border-color: #409eff;
    }
  }
  &.is-past {
    color: #c0c4cc;
    background: #f5f7fa;
  }
  &.is-selected {
    background: #409eff;
    color: #fff;
    font-weight: 600;
  }
  .apt-check {
    position: absolute;
    right: 2px;
    bottom: 0;
    font-size: 10px;
  }
}
.apt-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}
.apt-mode-row {
  margin: 14px 0 10px;
}
.apt-slots-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.apt-slots-title {
  font-weight: 600;
  color: #303133;
}
.apt-selected-count {
  color: #909399;
  font-size: 12px;
}
.apt-quota-btn {
  margin-left: auto;
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  &.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
.apt-empty {
  color: #909399;
  font-size: 13px;
  text-align: center;
  padding: 24px 0;
}
.apt-date-group {
  margin-bottom: 12px;
}
.apt-date-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.apt-slot-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  .apt-quota-input {
    width: 100px;
  }
}
.apt-zhi {
  color: #909399;
}
.apt-del {
  font-size: 18px;
  color: #f56c6c;
  cursor: pointer;
  &.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
.apt-lock-text {
  color: #f56c6c;
  font-size: 12px;
}
.apt-add-slot {
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
}
.apt-batch-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
